module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/cover_front_pastel_hyphen-2d52e3ed4a699ea851b62d1826f0599f.svg";